import React, { useEffect, useState, useMemo } from 'react'
import { useWeb3React } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { injectedConnector } from '../connectors/'
import { reactLocalStorage } from 'reactjs-localstorage'
import Web3 from 'web3'
import {
  SignType,
  UserSignUpType,
  AccessTokenType,
} from '../models/sign.interface'
import { authApi, userApi } from '../api/' //add
import {
  getCookieData,
  readCookie,
  setCookieData,
  deleteCookieData,
} from '../utils/cookieHelper'
import { useDispatch, useSelector } from 'react-redux'
import { authAff, setStateKey ,fetchAffInfo } from '../redux/slices/affiliateSlice'
import { useStake } from './useStake' 
import { useDex } from './useDex'
import { useWalletModalToggle }  from './useApplication'

let web3: Web3 | undefined = undefined // Will hold the web3 instance

export const useConnectWallet = () => {
  const {
    chainId,
    account,
    activate,
    library,
    deactivate,
  } = useWeb3React<Web3Provider>()
  const [isLoginAff, setLoginAff] = useState<any>(false)
  const  toggleWalletModal =   useWalletModalToggle()


  const dispatch = useDispatch()
  const { checkStaking ,getStakeBlance  } = useStake()
  const {  } = useDex()

  const connectWallet = () => {
    // activate(injectedConnector)
    // reactLocalStorage.set('isLogin', true)
    toggleWalletModal()
  }

  const disconnectWallet = () => {
    deactivate()
    reactLocalStorage.remove('isLogin')
    logoutAff()
  }

  const logoutAff = () =>{
    deleteCookieData('accessToken')
    deleteCookieData('refreshToken')
    deleteCookieData('token')
    reactLocalStorage.remove('accessToken')
    setStateLoginAff(false)
  }

  const connectWeb3 = async () => {
    try {
      // Request account access if needed
      await (window as any).ethereum.enable()

      // We don't know window.web3 version, so we use our own instance of Web3
      // with the injected provider given by MetaMask
      web3 = new Web3((window as any).ethereum)
    } catch (error) {
      console.log('not founf matamask')
      //   window.alert('You need to allow MetaMask.');
      return
    }
  }

  const sign = async (account: any, signData: string) => {
    const signature = await web3!.eth.personal.sign(
      `signature: ${signData}`,
      account,
      '', // MetaMask will ignore the password argument here
    )
    reactLocalStorage.set('signature', signature)

    return signature
  }

  const signInWithMatamark = async () => {
    try {
      await connectWeb3()
      const signRes: SignType = await authApi.verifySign(account)
      const signature = await sign(account, signRes.verifySignature)
      const userParam: UserSignUpType = {
        walletAddress: signRes.walletAddress,
        signature: signature,
      }
      const accessToken: AccessTokenType = await authApi.auth(userParam)

      setCookieData('accessToken', accessToken.token.accessToken)
      setCookieData('refreshToken', accessToken.token.refreshToken)
      setCookieData('token', JSON.stringify(accessToken))

      reactLocalStorage.set('accessToken', accessToken.token.accessToken)
      setStateLoginAff(true)
      dispatch(fetchAffInfo())
      const isStaking =  await  checkStaking(account)
      if(isStaking) {
        getStakeBlance(account)
        //getUserCommission()
      }

      return signature
    } catch (ex) {
      console.log(ex)
    }
  }

  const isSignIn = () => {
    const res = reactLocalStorage.get('accessToken')
    if (res) return true
    else return false
  }

  const setStateLoginAff = (status: boolean) => {
    dispatch(setStateKey({ key: 'isLoginAff', value: status }))
    dispatch(setStateKey({ key: 'isStaking', value: false }))
  }

  return {
    connectWallet,
    account,
    library,
    disconnectWallet,
    chainId,
    connectWeb3,
    sign,
    signInWithMatamark,
    isSignIn,
    isLoginAff,
    setLoginAff,
    setStateLoginAff,
    logoutAff
  }
}
